import { CHANGE_SELECTED_LOCATION } from '../constants/ActionTypes.js'

export const changeSelectedLocation = (location) => ({
  type: CHANGE_SELECTED_LOCATION,
  payload: location,
})